<template>
  <van-button
    loading-size="32"
    :type="type"
    v-bind="$attrs"
    v-on="$listeners"
    class="button"
    :class="pointClass"
  >
    <slot></slot>
  </van-button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    type: {
      type: String,
      default: 'primary' // primary为主要按钮；default为默认按钮
    },
    pointClass: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  height: 100px;
  border-radius: var(--border-radius);
  font-size: 28px;
}

// 默认背景
.van-button--default {
  background-color: var(--block-bg-light-color);
  border-color: var(--border-color);
  color: var(--text-color);
}

// 主调色背景
.van-button--primary {
  background-color: var(--main-color);
  border-color: var(--main-color);
  color: var(--text-on-main-bg-color);
}
</style>
